import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { __rest } from '../../../_virtual/_tslib.js';
import { Remediator } from '../Base/Remediator.js';
import { unwrapFormValue } from './util.js';
var GenericRemediator = /*#__PURE__*/function (_Remediator) {
  function GenericRemediator() {
    _classCallCheck(this, GenericRemediator);
    return _callSuper(this, GenericRemediator, arguments);
  }
  _inherits(GenericRemediator, _Remediator);
  return _createClass(GenericRemediator, [{
    key: "canRemediate",
    value: function canRemediate() {
      if (typeof this.remediation.action !== 'function') {
        return false;
      }
      if (this.remediation.name === 'poll' || this.remediation.name.endsWith('-poll')) {
        return true;
      }
      if (this.options.step) {
        return true;
      }
      return false;
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this = this;
      var data = this.getInputs().reduce(function (acc, _ref) {
        var name = _ref.name;
        acc[name] = _this.values[name];
        return acc;
      }, {});
      return data;
    }
  }, {
    key: "getNextStep",
    value: function getNextStep(authClient, _context) {
      var name = this.getName();
      var inputs = this.getInputs();
      var _a = this.remediation,
        href = _a.href,
        method = _a.method,
        rel = _a.rel,
        accepts = _a.accepts,
        produces = _a.produces,
        value = _a.value,
        action = _a.action,
        rest = __rest(_a, ["href", "method", "rel", "accepts", "produces", "value", "action"]);
      if (action) {
        return Object.assign(Object.assign(Object.assign({}, rest), !!inputs.length && {
          inputs: inputs
        }), {
          action: function () {
            var _action = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", authClient.idx.proceed(Object.assign({
                      step: name
                    }, params)));
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee);
            }));
            function action(_x) {
              return _action.apply(this, arguments);
            }
            return action;
          }()
        });
      }
      return Object.assign({}, this.remediation);
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      return (this.remediation.value || []).filter(function (_ref2) {
        var name = _ref2.name;
        return name !== 'stateHandle';
      }).map(unwrapFormValue).map(function (input) {
        input.type = input.type || 'string';
        return input;
      });
    }
  }]);
}(Remediator);
export { GenericRemediator };